import { defineStore } from 'pinia'
import { AnnStore } from '@/front/stores/ann_store.js'
import { preloadManager } from '@/front/services/PreloadManager.js'

export const ClipStore = defineStore('clip', {
  state: () => {
    return {
      player: null,
      currentTime: 0,
      aspectRatio: null,
      playerState: {},
      requestedAt: null,
      startedAt: null,
      src: null,
    }
  },

  actions: {
    setPlayerState(state) {
      this.playerState = state
      this.aspectRatio = state.width / state.height
      // log.info(3,"🔎 ClipStore setPlayerState", this.aspectRatio)
    },
    setSrc(src) {
      this.src = src
    },
    togglePlay() {
      this.playerState.playing ? this.player.pause() : this.player.play()
    },
    seekToPercentage(percentage) {
      log.info(2,"seekToPercentage", percentage)
      this.playerStore.seek((percentage / 100) * this.playerState.duration)
    },
    clear() {
      this.src = null
      this.playerState = {}
    },
    async streamById(id) {
      this.clear()
      log.info(2,"🌜 ClipStore streamById", id)
      this.requestedAt = Date.now()

      // Check preload cache first
      const preloaded = preloadManager.getPreloadedClip(id)
      if (preloaded && preloaded.type === 'video') {
        log.info(2,"🔊 ClipStore using preloaded video", id)
        this.src = preloaded.url
        return Promise.resolve()
      }

      // Fallback to regular loading
      return this.Api.get(`/assets/stream/${id}`).then(response => {
        log.info(2,"🔊 ClipStore streamById response", response.data)
        this.src = response.data.url
      })
    }
  },
  getters: {
    progress: (state) => Math.round((state.currentTime / state.playerState.duration) * 100),
  }
})